import styled from "styled-components";

export default styled.div`
  background-color: #edebe1;
  border-radius: 100%;
  height: 150px;
  width: 150px;
  &:before {
    opacity: 0;
    font-family: "Material Icons";
    color: #ffffff;
    position: absolute;
    border-radius: 100%;
    top: 0;
    left: 0;
    height: 150px;
    width: 150px;
    background-color: rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2rem;
    direction: ltr;
    -webkit-font-feature-settings: "liga";
    -webkit-font-smoothing: antialiased;
  }
  img {
    border-radius: 100%;
    width: 200px;
    height: 150px;
  }
  &:hover:before {
    content: "camera_alt";
    cursor: pointer;
    opacity: 1;
  }
  ${({ isOver }) =>
    isOver &&
    `
    &:before {
      opacity: 1;
    }
  `};
`;



// WEBPACK FOOTER //
// ./src/components/generic/form/formik/PhotoUpload/Avatar.js